module.exports = __webpack_public_path__ + "img/dorethea-dix.4aa66cc9.png";